import { giphyLightCharcoal } from '@giphy/colors'
import { SyntheticEvent } from 'react'
import IconTooltip from 'shared/components/ui/icon-tooltip'
import styled from 'styled-components'
import { ISegment } from '../../shared/types'

const Menu = styled.div`
    bottom: 5px;
    height: 30px;
    line-height: 30px;
    position: absolute;
    right: 5px;
    width: 30px;

    > div {
        margin-left: -8px;
        margin-top: -6px;
    }

    .ss-ellipsis {
        font-size: 20px;

        &:before {
            display: block;
            transform: rotate(90deg);
        }
    }
`

const Item = styled.div`
    color: ${giphyLightCharcoal};
    cursor: pointer;
`

type Props = {
    className?: string
    segment: ISegment
    onDuplicate: (e: SyntheticEvent<HTMLDivElement, MouseEvent>) => void
    onDelete: (e: SyntheticEvent<HTMLDivElement, MouseEvent>) => void
    onRevert: (e: SyntheticEvent<HTMLDivElement, MouseEvent>) => void
    onMergeHover?: (direction?: 'left' | 'right') => void
    onMergeRight?: (e: SyntheticEvent<HTMLDivElement, MouseEvent>) => void
    onMergeLeft?: (e: SyntheticEvent<HTMLDivElement, MouseEvent>) => void
}

const SupercutGridCellMenu = ({
    className,
    segment,
    onDuplicate,
    onDelete,
    onRevert,
    onMergeHover,
    onMergeRight,
    onMergeLeft,
}: Props) => {
    const onMergeItemOver = (direction?: 'left' | 'right') => {
        onMergeHover && onMergeHover(direction)
    }

    return (
        <Menu className={className}>
            <IconTooltip icon="ss-ellipsis" color="#fff">
                <Item onClick={onDelete}>Delete</Item>
                <Item onClick={onDuplicate}>Duplicate</Item>
                {!!onMergeLeft && (
                    <Item
                        onMouseOver={() => onMergeItemOver('left')}
                        onMouseOut={() => onMergeItemOver()}
                        onClick={onMergeLeft}
                    >
                        Merge Left
                    </Item>
                )}
                {!!onMergeRight && (
                    <Item
                        onMouseOver={() => onMergeItemOver('right')}
                        onMouseOut={() => onMergeItemOver()}
                        onClick={onMergeRight}
                    >
                        Merge Right
                    </Item>
                )}
                {segment.editParams && !segment.editParams.isMerged && (
                    <Item onClick={onRevert}>Revert to Original</Item>
                )}
            </IconTooltip>
        </Menu>
    )
}

export default SupercutGridCellMenu
